import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from "./SortPagesPanel.css";
import { AppAdminStore } from '../stores';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAppPage } from '../../../interfaces/IAppPage';
import { IAIcon } from '../../icon/Icon';
import { IAPanel } from '../../panels';

export interface IProps {
  appAdminStore?: AppAdminStore;
  open: boolean;
  hasChanged?: () => void;
}

export interface IState {
}

@inject('appAdminStore')
@observer
export class SortPagesPanel extends React.Component<IProps, IState> {

  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    const pages = [];
    this.props.appAdminStore.instance?.settings?.menu?.forEach((page: IAppPage, index) => {
      pages.push(
        <div
          className={styles.IA_sortingPage}
          key={index}
        >
          <IAIcon
            title={page.icon}
            size={18}
            color={"#333333"}
            style={{
              float: "left",
              marginTop: 16,
              marginLeft: 16
            }}
          />
          <div
            className={styles.IA_sortingPageText}
            style={{
              color: page.title ? "#333333" : "#999999"
            }}
          >
            {page.title ? page.title : this.localizationService.strings.AppAdmin_NoPageTitle}
          </div>
          <IAIcon
            url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Arrow%20Down/SVG/ic_fluent_arrow_down_48_regular.svg"
            size={18}
            color={index < this.props.appAdminStore.instance?.settings?.menu.length - 1 ? "#23879b" : "#eeeeee"}
            onClick={() => {
              if (index < this.props.appAdminStore.instance?.settings?.menu.length - 1) {
                var element = this.props.appAdminStore.instance?.settings?.menu[index];
                this.props.appAdminStore.instance?.settings?.menu.splice(index, 1);
                this.props.appAdminStore.instance?.settings?.menu.splice(index + 1, 0, element);
                this.props.appAdminStore.checkForChanges();
                this.props.hasChanged();
              }
            }}
            style={{
              float: "right",
              marginTop: 16,
              marginRight: 16,
              cursor: index < this.props.appAdminStore.instance?.settings?.menu.length - 1 ? "pointer" : "default"
            }}
          />
          <IAIcon
            url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Arrow%20Up/SVG/ic_fluent_arrow_up_48_regular.svg"
            size={18}
            color={
              index === 0 ||
                (this.props.appAdminStore.instance?.settings?.menu[index] && this.props.appAdminStore.instance?.settings?.menu[index]?.components[0] && this.props.appAdminStore.instance?.settings?.menu[index]?.components[0].type === "IntraActive-NavigatorAdmin" && index === 1) ||
                (this.props.appAdminStore.instance?.settings?.menu[index] && this.props.appAdminStore.instance?.settings?.menu[index]?.components[0] && this.props.appAdminStore.instance?.settings?.menu[index]?.components[0].type === "IntraActive-ContentOrganizer" && index === 1) ?
                "#eeeeee" : "#23879b"
            }
            onClick={() => {
              if (index === 0 || (this.props.appAdminStore.instance?.settings?.menu[index] && this.props.appAdminStore.instance?.settings?.menu[index]?.components && this.props.appAdminStore.instance?.settings?.menu[index]?.components[0] && this.props.appAdminStore.instance?.settings?.menu[index]?.components[0].type === "IntraActive-NavigatorAdmin" && index === 1) || (this.props.appAdminStore.instance?.settings?.menu[index] && this.props.appAdminStore.instance?.settings?.menu[index]?.components[0] && this.props.appAdminStore.instance?.settings?.menu[index]?.components[0].type === "IntraActive-ContentOrganizer" && index === 1)) {
              } else {
                var element = this.props.appAdminStore.instance?.settings?.menu[index];
                this.props.appAdminStore.instance?.settings?.menu.splice(index, 1);
                this.props.appAdminStore.instance?.settings?.menu.splice(index - 1, 0, element);
                this.props.appAdminStore.checkForChanges();
                this.props.hasChanged();
              }
            }}
            style={{
              float: "right",
              marginTop: 16,
              marginRight: 16,
              cursor: index > 0 ? "pointer" : "default"
            }}
          />
        </div>
      );
    });
    return (
      <IAPanel
        showNavigationBar={true}
        component={"AppAdmin"}
        open={this.props.appAdminStore.sortPages}
        transition="slide"
        width={600}
        isMobile={false}
        highlightColor={"#23879b"}
        marginTop={location.origin.indexOf("sharepoint.com") !== -1 ? 159 : 50}
        overlayColor={"transparent"}
        disableSaving={this.props.appAdminStore.isSaving}
        close={() => {
          this.props.appAdminStore.sortPages = false;
        }}
      >
        <div
          id="IA_SortPagesPanel"
        >
          {pages}
        </div>
      </IAPanel>
    );
  }


}